import { render, staticRenderFns } from "./ToastItem.vue?vue&type=template&id=36383956&scoped=true"
import script from "./ToastItem.vue?vue&type=script&lang=js"
export * from "./ToastItem.vue?vue&type=script&lang=js"
import style0 from "./ToastItem.vue?vue&type=style&index=0&id=36383956&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36383956",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Ftoast-item%2FToastItem.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports